import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ImageTextCta",
    component: () => (__SERVER__ ? require("./image-text-cta-view") : import("./image-text-cta-view"))
});

export default definition;
